module.exports = __webpack_public_path__ + "static/DataStrategy_128virtual-d04f90e4a0a3b2e4a38987c9ee927031.png";